// Loop target parser for `@for(item, source)` and `@for((item,index), source)`.
// Example: `@for((bp,ind), var(--breakpoints))`.
import { splitTopLevelByComma } from './scanner-utils'

export type ParsedLoopTarget = {
  variableName: string
  indexVariableName?: string
}

// Parse first @for argument and return item/index variable names.
export function parseLoopTargetArgument(argument: string): ParsedLoopTarget | null {
  const trimmed = argument.trim()
  // Parse tuple target form: `(item,index)`.
  if (trimmed.startsWith('(') && trimmed.endsWith(')')) {
    return parseTupleTarget(trimmed)
  } else if (isValidLoopVariableName(trimmed)) {
    // Return single-variable target form: `item`.
    return { variableName: trimmed }
  } else {
    // Return null when target syntax is invalid.
    return null
  }
}

// Parse `(item,index)` tuple target and validate both names.
function parseTupleTarget(target: string): ParsedLoopTarget | null {
  const inner = target.slice(1, -1)
  const parts = splitTopLevelByComma(inner).map((entry) => entry.trim())
  // Reject tuple forms that do not contain exactly 2 identifiers.
  if (parts.length !== 2) {
    return null
  } else {
    // Continue tuple variable-name validation.
  }

  const variableName = parts[0]
  const indexVariableName = parts[1]
  // Reject tuple forms with invalid item variable name.
  if (!isValidLoopVariableName(variableName)) {
    return null
  } else if (!isValidLoopVariableName(indexVariableName)) {
    // Reject tuple forms with invalid index variable name.
    return null
  } else {
    // Return parsed tuple target names.
    return { variableName, indexVariableName }
  }
}

// Validate one loop variable name.
function isValidLoopVariableName(name: string): boolean {
  // Regex validates loop variable identifiers used in scopes.
  return /^[a-zA-Z_][\w-]*$/.test(name)
}

